import { Popover, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { Fragment } from 'react';

import { Button as EditorButton } from '~components/generic/editor/Button/Button';
import { Hint } from '~components/generic/editor/Hint/Hint';
import { DeleteIcon } from '~components/icons';
import useLabels from '~hooks/useLabels';
import styles from './DeleteModulePopover.css';

export function DeleteModulePopover({ onDelete }: { onDelete: () => void }) {
  const { btnDelete, btnDeleteConfirm, btnDeleteCancel, msgItemDelete } = useLabels([
    'btnDelete',
    'btnDeleteConfirm',
    'btnDeleteCancel',
    'msgItemDelete',
  ]);
  return (
    <Popover className={`relative flex`}>
      {({ open, close }) => (
        <>
          <Popover.Button as={EditorButton} title={btnDelete} icon={<DeleteIcon />} disabled={open} />
          <Transition
            show={open}
            as={Fragment}
            enter={`transition ease-out duration-200`}
            enterFrom={`opacity-0 -translate-y-1`}
            enterTo={`opacity-100 translate-y-0`}
            leave={`transition ease-in duration-150`}
            leaveFrom={`opacity-100 translate-y-0`}
            leaveTo={`opacity-0 -translate-y-1`}
          >
            <Popover.Panel as={Hint} className={clsx(styles.panel, `absolute z-50 mt-40 transform right-0 `)}>
              <div className={`block`}>
                <div>{msgItemDelete}</div>
                <div className={`mt-4 flex justify-end`}>
                  <EditorButton onClick={() => close()} label={btnDeleteCancel} />
                  <div className="mx-2" />
                  <EditorButton
                    icon={<DeleteIcon />}
                    onClick={() => {
                      onDelete();
                      close();
                    }}
                    label={btnDeleteConfirm}
                  />
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
